<template>
  <main>
    <div class="p-2 mt-5 bg-white rounded-lg shadow-md">
      <section class="flex items-center justify-between p-2 border border-gray-400">
        <div class="filter-grid flex-none flex">
          <button class="button focus:outline-none hover:text-gray-700 px-3 font-medium leading-6 text-gray-600 cursor-pointer">
            <RefreshCcwIcon size="1x" class="mr-2" />
          </button>
          <div class="relative">
            <input type="text" name="inputsearch" class="h-10 w-72 pl-2 pr-20 border border-gray-400 z-0 focus:shadow focus:outline-none" v-model="searchInput" @keydown="showHideCancel" />
            <div class="search-action absolute top-2 right-2">
              <button @click="clearInput" class="text-gray-500 py-1" v-show="isShowCancel"><x-icon size="1.5x" class="custom-class"></x-icon></button>
              <button @click="searchInput" class="text-gray-500 py-1"><search-icon size="1.5x" class="custom-class"></search-icon></button>
            </div>
          </div>
          <button class="text-gray-500 py-1 ml-1" @click="showModal" v-click-outside="closeModal"><filter-icon size="1.5x" class="custom-class"></filter-icon></button>
        </div>
        <div class="flex-1 text-right text-blue-900">{{ selectedRows.length }} of {{ tableRows.length }} selected</div>
      </section>
      <section>
        <div id="sixthTable">
          <table class="w-full">
            <thead>
              <tr class="border border-t-0 border-gray-400">
                <th><input v-if="multiSelectEnabled" type="checkbox" @click="selectAll()" v-model="isAllSelected" /></th>
                <th v-for="col in columns" @click="sortTable(col.field)" :key="col.field" class="text-left cursor-pointer bg-white text-gray-400 p-2 min-w-40%">
                  <span v-if="col.visible">{{ col.text }}</span>
                  <div class="arrow" v-if="col.field == sortColumn">
                    <chevron-down-icon size="1.5x" class="custom-class" v-show="ascending"></chevron-down-icon>
                    <chevron-up-icon size="1.5x" class="custom-class" v-show="!ascending"></chevron-up-icon>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in getRows()" :key="row.id" class="border border-t-0 border-gray-400">
                <td class="text-center p-2 last:pb-10 last:border-r-0"><input type="checkbox" v-model="selectedRows" :value="row.id" @change="updateSelectAll(row.id)" /></td>
                <td v-for="col in columns" :key="col.field" class="text-left p-2 last:pb-10 last:border-r-0 text-blue-900">
                  <span v-if="col.visible">{{ row[col.field] }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="w-full text-right p-2">
            <div>
              <select v-model="selectedElementPerPage" @change="onChangeElementPerPage()" class="border border-2 border-gray-400 mb-1.5 text-gray-600">
                <option v-for="itemPerPage in elementPerPage" :value="itemPerPage" :key="itemPerPage">{{ itemPerPage }}</option>
              </select>
            </div>
            <div class="number" v-for="i in numPages()" :key="i" :class="[i == currentPage ? 'active' : '']" @click="changePage(i)">{{ i }}</div>
          </div>
        </div>
      </section>
    </div>
    <!-- <TableFilterModal v-show="isModalVisible" @close="closeModal" :data-field="columns" /> -->
    <div v-show="isModalVisible" class="modal-filter fixed inset-0 w-full h-screen flex mt-2 justify-center bg-semi-75 h-fit z-40">
      <div class="w-full max-w-md bg-white shadow-lg rounded-lg border border-gray-400">
        <header class="modal-header bg-gray-200 text-gray-400 p-2 overflow-hidden">
          <button @click="FilterGrid()">Apply Now</button>
          <button type="button" class="btn-close float-right" @click="closeModal">Close</button>
        </header>

        <section class="modal-filter-body max-h-screen overflow-y-auto">
          <div v-for="col in columns" :key="col.field">
            <div @click.self="col.showToggle = !col.showToggle" class="border border-gray-100 px-2 pb-2 mb2">
              {{ col.text }}
              <div class="filter-data" v-show="col.showToggle">
                <div v-if="col.datatype == 'string'">
                  <input type="text" v-model="col.value" class="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" />
                </div>
                <div v-if="col.datatype == 'number'">
                  <input type="number" v-model="col.value" class="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" />
                </div>
                <div v-if="col.datatype == 'date'" class="xl:flex lg:flex md:flex block">
                  <div class="xl:w-1/2 lg:w-1/2 md:w-1/2 w-full pr-2">
                    <label>From </label>
                    <input
                      type="date"
                      :id="'start-' + col.text"
                      :name="'start-' + col.text"
                      v-model="col.value.from"
                      class="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    />
                  </div>
                  <div class="xl:w-1/2 lg:w-1/2 md:w-1/2 w-full">
                    <label>To </label>
                    <input
                      type="date"
                      :id="'end-' + col.text"
                      :name="'end-' + col.text"
                      v-model="col.value.to"
                      class="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    />
                  </div>
                </div>
                <div v-if="col.datatype == 'datetime-local'" class="xl:flex lg:flex md:flex block">
                  <div class="xl:w-1/2 lg:w-1/2 md:w-1/2 w-full pr-2">
                    <label>From </label>
                    <input
                      type="datetime-local"
                      :id="'start-' + col.text"
                      :name="'start-' + col.text"
                      v-model="col.value.from"
                      class="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    />
                  </div>
                  <div class="xl:w-1/2 lg:w-1/2 md:w-1/2 w-full">
                    <label>To </label>
                    <input
                      type="datetime-local"
                      :id="'end-' + col.text"
                      :name="'end-' + col.text"
                      v-model="col.value.to"
                      class="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </main>
</template>
<script>
import { defineComponent, onMounted, ref, reactive } from 'vue';
// eslint-disable-next-line object-curly-newline
import { RefreshCcwIcon, SearchIcon, XIcon, ChevronDownIcon, ChevronUpIcon, FilterIcon } from 'vue-feather-icons';
// import { TableFilterModal } from './TableFilterModal.vue';

export default defineComponent({
  name: 'ExecutionTable',
  props: {
    rows: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    multiSelectEnabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RefreshCcwIcon,
    SearchIcon,
    XIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    FilterIcon,
    // TableFilterModal,
  },
  setup(props) {
    const searchInput = ref('');
    const isShowCancel = ref(false);
    const currentPage = ref(1);
    const elementPerPage = ref([5, 10, 15, 20]);
    const selectedElementPerPage = ref(elementPerPage.value[0]);
    const ascending = ref(false);
    const sortColumn = ref('');
    const selectedRows = ref([]);
    const isAllSelected = ref(false);
    const isModalVisible = ref(false);
    const showTick = ref(false);
    const filterData = reactive({});
    // const multiSelectEnabled = ref(true);
    // console.log(`props.rows ${props.rows}`);
    // console.log(`props.columns ${JSON.stringify(props.columns)}`);
    const tableRows = [];

    watch(
      () => props.rows,
      () => {
        tableRows = props.rows;
      },
    );
    // console.log('Tabl Rows', tableRows);
    // console.log('Table Rows', props.rows);
    // const rows = ref([
    //   {
    //     id: 1,
    //     name: 'Chandler Bing',
    //     phone: '305-917-1301',
    //     profession: 'IT Manager',
    //     registrationDate: '01-01-2020',
    //     createdDate: '01-01-2020',
    //   },
    //   {
    //     id: 2,
    //     name: 'Ross Geller',
    //     phone: '210-684-8953',
    //     profession: 'Paleontologist',
    //     registrationDate: '01-01-2020',
    //     createdDate: '01-01-2020',
    //   },
    //   {
    //     id: 3,
    //     name: 'Rachel Green',
    //     phone: '765-338-0312',
    //     profession: 'Waitress',
    //     registrationDate: '01-01-2020',
    //     createdDate: '01-01-2020',
    //   },
    //   {
    //     id: 4,
    //     name: 'Monica Geller',
    //     phone: '714-541-3336',
    //     profession: 'Head Chef',
    //     registrationDate: '01-01-2020',
    //     createdDate: '01-01-2020',
    //   },
    //   {
    //     id: 5,
    //     name: 'Joey Tribbiani',
    //     phone: '972-297-6037',
    //     profession: 'Actor',
    //     registrationDate: '01-01-2020',
    //     createdDate: '01-01-2020',
    //   },
    //   {
    //     id: 6,
    //     name: 'Phoebe Buffay',
    //     phone: '760-318-8376',
    //     profession: 'Masseuse',
    //     registrationDate: '01-01-2020',
    //     createdDate: '01-01-2020',
    //   },
    //   {
    //     id: 7,
    //     name: 'Chandler Bing',
    //     phone: '305-917-1301',
    //     profession: 'IT Manager',
    //     registrationDate: '01-01-2020',
    //     createdDate: '01-01-2020',
    //   },
    //   {
    //     id: 8,
    //     name: 'Ross Geller',
    //     phone: '210-684-8953',
    //     profession: 'Paleontologist',
    //     registrationDate: '01-01-2020',
    //     createdDate: '01-01-2020',
    //   },
    //   {
    //     id: 9,
    //     name: 'Rachel Green',
    //     phone: '765-338-0312',
    //     profession: 'Waitress',
    //     registrationDate: '01-01-2020',
    //     createdDate: '01-01-2020',
    //   },
    //   {
    //     id: 10,
    //     name: 'Monica Geller',
    //     phone: '714-541-3336',
    //     profession: 'Head Chef',
    //     registrationDate: '01-01-2020',
    //     createdDate: '01-01-2020',
    //   },
    //   {
    //     id: 11,
    //     name: 'Joey Tribbiani',
    //     phone: '972-297-6037',
    //     profession: 'Actor',
    //     registrationDate: '01-01-2020',
    //     createdDate: '01-01-2020',
    //   },
    //   {
    //     id: 12,
    //     name: 'Phoebe Buffay',
    //     phone: '760-318-8376',
    //     profession: 'Masseuse',
    //     registrationDate: '01-01-2020',
    //     createdDate: '01-01-2020',
    //   },
    // ]);
    // const columns = ref([
    //   { field: 'id', text: 'Id', datatype: 'number', showToggle: false, value: '' },
    //   { field: 'name', text: 'Name', datatype: 'string', showToggle: false, value: '' },
    //   { field: 'phone', text: 'Phone', datatype: 'string', showToggle: false, value: '' },
    //   { field: 'profession', text: 'Profession', datatype: 'string', showToggle: false, value: '' },
    //   {
    //     field: 'createdDate',
    //     text: 'Created Date',
    //     datatype: 'datetime-local',
    //     showToggle: false,
    //     value: { from: '', to: '' },
    //   },
    //   { field: 'registrationDate', text: 'Registration Date', datatype: 'date', showToggle: false, value: { from: '', to: '' } },
    // ]);
    onMounted(async () => {
      props.columns.forEach((col) => {
        if (col.datatype === 'date' || col.datatype === 'datetime-local') {
          filterData[col.field] = {
            from: '',
            to: '',
          };
        } else {
          filterData[col.field] = '';
        }
      });
      // console.log(`filterData ${JSON.stringify(filterData)}`);
    });
    const showHideCancel = () => {
      if (searchInput.value.length === 0) isShowCancel.value = false;
      else isShowCancel.value = true;
    };
    const sortTable = (col) => {
      // console.log();
      if (sortColumn.value === col) {
        ascending.value = !ascending.value;
      } else {
        ascending.value = true;
        sortColumn.value = col;
      }
      const ascend = ascending.value;
      tableRows.sort((a, b) => {
        if (a[col] > b[col]) {
          return ascend ? 1 : -1;
        }
        if (a[col] < b[col]) {
          return ascend ? -1 : 1;
        }
        return 0;
      });
    };
    const numPages = () => {
      const res = Math.ceil(tableRows.length / selectedElementPerPage.value);
      return res;
    };
    const getRows = () => {
      const start = (currentPage.value - 1) * selectedElementPerPage.value;
      const end = start + selectedElementPerPage.value;
      return tableRows.slice(start, end);
    };
    const selectAll = () => {
      isAllSelected.value = !isAllSelected.value;
      selectedRows.value = [];
      // console.log(`getRows() ${getRows()}`);
      if (isAllSelected.value) {
        selectedRows.value = getRows().map((row) => row.id);
        // console.log(`selectedRows ${selectedRows.value}`);
        // getRows().forEach((row) => {
        //   selectedRows.value.push(row.id);
        // });
      }
    };
    const updateSelectAll = (value) => {
      console.log('updateSelectAll Called', value);
      if (props.multiSelectEnabled) {
        if (getRows().length === selectedRows.value.length) {
          isAllSelected.value = true;
        } else isAllSelected.value = false;
      } else {
        selectedRows.value = [];
        selectedRows.value.push(value);
      }
    };
    const changePage = (page) => {
      currentPage.value = page;
      updateSelectAll();
    };
    const closeModal = () => {
      isModalVisible.value = false;
    };
    const showModal = () => {
      isModalVisible.value = true;
    };
    const FilterGrid = () => {
      // console.log('inside filter');
      props.columns.forEach((col) => {
        if (col.datatype === 'date' || col.datatype === 'datetime-local') {
          filterData[col.field] = {
            from: col.value.from,
            to: col.value.to,
          };
        } else {
          filterData[col.field] = col.value;
        }
      });
      // console.log(`inside filterdata ${JSON.stringify(filterData)}`);
    };
    const onChangeElementPerPage = () => {
      updateSelectAll(null);
    };
    const clearInput = () => {
      searchInput.value = '';
      isShowCancel.value = false;
    };
    return {
      searchInput,
      isShowCancel,
      showHideCancel,
      currentPage,
      elementPerPage,
      selectedElementPerPage,
      ascending,
      sortColumn,
      sortTable,
      numPages,
      getRows,
      changePage,
      selectedRows,
      selectAll,
      updateSelectAll,
      isAllSelected,
      isModalVisible,
      closeModal,
      showModal,
      showTick,
      filterData,
      FilterGrid,
      onChangeElementPerPage,
      clearInput,
      tableRows,
    };
  },
});
</script>
<style scoped>
.search-action {
  margin-top: -0.3rem;
}
.modal-filter {
  height: fit-content;
}

.modal-filter-body {
  min-height: 200px;
}
/* table,
td {
  border: 0.5px solid rgb(202 202 202 / 30%);
} */
/* table {
  font-family: 'Open Sans', sans-serif;
  width: 750px;
  border-collapse: collapse;
  border: 3px solid #44475c;
  margin: 10px 10px 0 10px;
} */

/* table th {
  /* text-transform: uppercase;
  text-align: left;
  background: #727277;
  color: rgb(255, 255, 255);
   cursor: pointer;
  padding: 8px;
  min-width: 30px;
  } */
/* table th:hover {
  background: #717699;
} */
/* table td {
  text-align: left;
  padding: 8px;
  border-right: 2px solid #7d82a8;
} */
/* table td:last-child {
  border-right: none;
} */
/* table tbody tr:nth-child(2n) td {
  background: #d4d8f9;
} */

.arrow {
  float: right;
  width: 12px;
  height: 15px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position-y: bottom;
}

.number {
  display: inline-block;
  padding: 4px 10px;
  color: #fff;
  border-radius: 4px;
  background: #44475c;
  margin: 0px 5px;
  cursor: pointer;
}
.number:hover,
.number.active {
  background: #717699;
}
</style>
